module.exports = __webpack_public_path__ + "static/media/headerImg1_v2.9a091b89.jpg";